import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Where an inbox event came from: a GitHub webhook, a Linear webhook, an agent
 * callback, a human reply, a fan-out instance change, a manual injection, or a
 * projection of the resources seam's event log (OL-262).
 *
 * @since 1.0.0
 */
export const LoopEventSource = Schema.Literal(
  "github",
  "linear",
  "callback",
  "human",
  "fanout",
  "manual",
  "resource",
);
export type LoopEventSource = Schema.Schema.Type<typeof LoopEventSource>;

/**
 * Loop inbox event model — one external signal in a per-invocation inbox
 * (OL-203).
 *
 * Named `LoopInboxEvent` (not `LoopEvent`) deliberately: the interpreter's
 * `LoopEvent` union is a different, cluster-side type, and one name for two
 * shapes would be a trap. `customerId` / `invocationId` are by id only.
 *
 * @since 1.0.0
 */
export class LoopInboxEvent extends Model.Class<LoopInboxEvent>("LoopInboxEvent")({
  id: Model.Generated(Schema.String),

  customerId: Schema.String,

  invocationId: Schema.String,

  event: Schema.String,
  key: Schema.String,

  payload: Schema.NullOr(Schema.Unknown),

  source: LoopEventSource,

  dedupeKey: Schema.String,

  receivedAt: Model.DateTimeInsertFromDate,
  consumedAt: Schema.NullOr(Schema.DateTimeUtc),
  consumedSeq: Schema.NullOr(Schema.Number),
}) {}
